import { Table } from "lucide-react";

import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import useLucideIcons from "components/icons/useLucideIcons";

const DEFAULT_ICON_NAME = "table";

/**
 * Render the lucide glyph for a stored icon-name string. An empty name, or a
 * name lucide does not export, or an icon set that fails to load, renders the
 * table glyph so a missing icon never breaks layout.
 *
 * @param {object} props
 * @param {string} props.name - lucide icon name (the stored identity).
 */
export default function NamedIcon({ name, className, ...props }) {
  const { data: iconSet, isError } = useLucideIcons();
  const key = name || DEFAULT_ICON_NAME;

  if (key === DEFAULT_ICON_NAME || isError) {
    return <Table className={className} {...props} />;
  }

  // Holds the glyph's box until the icon set arrives, so layout does not shift.
  if (!iconSet) {
    return (
      <Skeleton
        aria-hidden="true"
        className={cn(
          "tw:inline-block tw:size-4 tw:shrink-0 tw:rounded-full",
          className
        )}
      />
    );
  }

  return (
    <iconSet.NamedLucideIcon name={key} className={className} {...props} />
  );
}
